import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.smtp-mandant-options';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationSmtpMandantOptionsEffects {

    SmtpMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_SMTP_MANDANT_OPTIONS),
        mergeMap((x: ac.GetSmtpMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getSmtpMandantOptions().pipe(
                map((result: any) => {
                    return new ac.GetSmtpMandantOptionsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetSmtpMandantOptionsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketQueryService);
        }
        return this.service;
    }
}
